import { type FC } from 'react';
import { Space } from '@g2u/ui-kit';
import { Card, Empty, Flex } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Pagination } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/a11y';

import { Section } from 'components';
import useUserInfo from 'hooks/useUserInfo';

import { TodaysPerformance, GeekSkill, GeekTasks } from './components';
import styles from './dashboard.module.scss';

export const DashboardPage: FC = () => {
  const [user, isLoading] = useUserInfo();

  return (
    <div data-testid="home-page" className={styles.dashboard}>
      <title>Dashboard</title>
      <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle} className={styles.dashboard__content}>
        <Flex gap="middle" wrap="wrap">
          <TodaysPerformance />
          <GeekTasks />
        </Flex>
        <Section full type="inner">
          <Card.Meta title="My GeekSkills" style={{ paddingBottom: 'var(--space-sm)' }} />
          {isLoading || !!user?.skillsets.length ? (
            <Swiper
              className={styles.dashboard__geekskills__carousel}
              modules={[Pagination, A11y]}
              pagination={{
                clickable: true,
                bulletClass: styles.dashboard__geekskills__carousel_bullets,
                bulletActiveClass: styles.dashboard__geekskills__carousel_bullets_active,
                horizontalClass: styles.dashboard__geekskills__carousel_track,
              }}
              spaceBetween={16}
              slidesPerGroup={3}
              slidesPerView={3}
            >
              {(isLoading
                ? Array(3)
                    .fill(null)
                    .map((_, i) => <GeekSkill key={`skeleton.${i}`} loading />)
                : user?.skillsets.map((skill, i) => <GeekSkill key={`${skill.name}.${i}`} {...skill} />)
              )?.map((item, i) => (
                <SwiperSlide className={styles.dashboard__geekskills__carousel_slide} key={`slide.${i}`}>
                  {item}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className={styles.dashboard__geekskills__empty} />
          )}
        </Section>
      </Space.$>
    </div>
  );
};
